"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentDetailsSchema = void 0;
var tslib_1 = require("tslib");
var UnAuthenticatedDetails_1 = require("../../components/UnAuthenticatedDetails");
var yup = tslib_1.__importStar(require("yup"));
exports.paymentDetailsSchema = yup.object().shape({
    paymentDetails: yup.object().shape({
        paymentAmount: yup
            .string()
            .test({
            name: 'is empty',
            message: 'Please enter payment amount.',
            test: function (val) {
                var cleanedAmount = val || '';
                if (cleanedAmount.startsWith('$')) {
                    cleanedAmount = cleanedAmount.slice(1);
                }
                if (cleanedAmount.length > 0)
                    return true;
                return false;
            }
        })
            .test({
            name: 'is greater than 0',
            message: 'Please enter a valid payment amount.',
            test: function (val) {
                var numericValue = val || '';
                if (numericValue.startsWith('$')) {
                    numericValue = numericValue.slice(1);
                }
                var floatAmount = parseFloat(numericValue);
                if (typeof floatAmount === 'number' && floatAmount > 0)
                    return true;
                return false;
            }
        }),
        cardName: yup
            .string()
            .required('Please enter Name on card.')
            .max(100, 'A name must not exceed 100 characters.')
            .test({
            name: 'name validation',
            message: 'Please enter a name only containing letters. Hyphens and spaces may also be used between names.',
            test: function (name) {
                var nameValue = name || '';
                var nameRegex = /^[a-zA-Z]+([-?\s?'?][a-zA-Z]+)*$/;
                return nameRegex.test(nameValue);
            }
        }),
        accountNumber: yup
            .number()
            .when(['$isUnAuthenticated'], function (isUnAuthenticated, schema) {
            return isUnAuthenticated
                ? schema
                    .required('Please enter account number.')
                    .test('len', 'Account number must be exactly 9 characters long.', function (val) {
                    return (val === null || val === void 0 ? void 0 : val.toString().length) === UnAuthenticatedDetails_1.accountNumberLength;
                })
                    .test({
                    name: 'validateNumber',
                    test: function (val) {
                        var _a, _b, _c;
                        return tslib_1.__awaiter(this, void 0, void 0, function () {
                            var onValidateAccountNumber, resp, error_1;
                            return tslib_1.__generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        onValidateAccountNumber = (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.onValidateAccountNumber;
                                        if (!(((_c = val === null || val === void 0 ? void 0 : val.toString()) === null || _c === void 0 ? void 0 : _c.length) === UnAuthenticatedDetails_1.accountNumberLength && onValidateAccountNumber)) return [3 /*break*/, 5];
                                        _d.label = 1;
                                    case 1:
                                        _d.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, onValidateAccountNumber(+val)];
                                    case 2:
                                        resp = _d.sent();
                                        if (resp.isAccountNumberValid) {
                                            return [2 /*return*/, true];
                                        }
                                        return [2 /*return*/, this.createError({
                                                message: resp.message,
                                                path: 'paymentDetails.accountNumber'
                                            })];
                                    case 3:
                                        error_1 = _d.sent();
                                        console.error('Failed to valid account number', error_1);
                                        return [2 /*return*/, this.createError({
                                                message: 'Failed to valid account number',
                                                path: 'paymentDetails.accountNumber'
                                            })];
                                    case 4: return [3 /*break*/, 6];
                                    case 5: return [2 /*return*/, true];
                                    case 6: return [2 /*return*/];
                                }
                            });
                        });
                    }
                })
                : schema;
        }),
        emailAddress: yup
            .string()
            .when(['$isUnAuthenticated'], function (isUnAuthenticated, schema) {
            return isUnAuthenticated
                ? schema.required('Please enter your email address.').test({
                    name: 'email validation',
                    message: 'Please enter a valid email address.',
                    test: function (email) {
                        var emailValue = email || '';
                        var emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
                        return emailRegex.test(emailValue);
                    }
                })
                : schema;
        })
    })
});
//# sourceMappingURL=validationSchema.js.map